import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";

export default function ({register, errors, control, data}) {

  return (
    <>
      <TextInput
        label="Store Name"
        name="name"
        register={register}
        required={true}
        errorMessage={errors?.name}
      />
      <ReactSelectInput
        label="Choose Address Town"
        name="town_id"
        placeholder="Choose"
        register={register}
        options={data?.towns}
        errorMessage={errors?.town_id}
        control={control}
      />
      <TextInput
        label="Street Address"
        name="address"
        register={register}
        errorMessage={errors?.address}
      />
      <TextInput
        label="Code"
        name="code"
        register={register}
        errorMessage={errors?.code}
      />

      <TextInput
        label="Store Latitude"
        name="latitude"
        register={register}
        required={true}
        errorMessage={errors?.latitude}
      />

      <TextInput
        label="Store Longitude"
        name="longitude"
        register={register}
        required={true}
        errorMessage={errors?.longitude}
      />

      {!data?.editMode &&
        <ReactSelectInput
          label="Choose Shop"
          name="shop_id"
          placeholder="Choose"
          register={register}
          options={data?.shops}
          errorMessage={errors?.shop_id}
          control={control}
        />}
    </>
  );
}